<template>
  <a-modal
    :visible="visible"
    title="导出记录"
    @cancel="$emit('close')"
    :footer="null"
    width="900px"
    :destroyOnClose="true"
  >
    <JeepayTable
      :tableColumns="columns"
      :reqTableDataFunc="reqTableDataFunc"
      :initData="true"
      :searchData="{}"
      rowKey="createdAt"
      :tableRowCrossColor="true"
      :pageSize="10"
    >
      <template slot="statusSlot" slot-scope="{record}">
        <a-tag v-if="record" :color="getExportStatusColor(record.status)">
          {{ getExportStatusText(record.status) }}
        </a-tag>
        <span v-else>--</span>
      </template>
      <template slot="createdAtSlot" slot-scope="{record}">
        <span v-if="record">{{ formatTimestamp(record.createdAt) }}</span>
        <span v-else>--</span>
      </template>
      <template slot="actionSlot" slot-scope="{record}">
        <a-button
          :disabled="!record || !record.ossAddress || record.status !== 1"
          type="link"
          icon="download"
          @click="openDownloadFile(record.bizId, record.fileName)"
        >
          下载
        </a-button>
      </template>
    </JeepayTable>
  </a-modal>
</template>

<script>
import moment from 'moment'
import JeepayTable from '@/components/JeepayTable/JeepayTable'
import { getExportStatusColor, getExportStatusText } from '@/utils/constants'
import axios from 'axios'
import storage from '@/utils/jeepayStorageWrapper'
import appConfig from '@/config/appConfig'

export default {
  name: 'ExportRecordModal',
  components: { JeepayTable },
  props: {
    visible: Boolean,
    reqTableDataFunc: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      columns: [
        {
          title: '导出时间',
          key: 'createdAt',
          width: 180,
          scopedSlots: { customRender: 'createdAtSlot' }
        },
        {
          title: '文件名',
          key: 'fileName',
          dataIndex: 'fileName',
          width: 200,
          customRender: (text) => text || '--'
        },
        {
          title: '状态',
          key: 'status',
          width: 100,
          scopedSlots: { customRender: 'statusSlot' }
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'actionSlot' }
        }
      ]
    }
  },
  methods: {
    getExportStatusColor,
    getExportStatusText,
    formatTimestamp (timestamp) {
      return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
    },
    // downloadFile (url, fileName) {
    //   const link = document.createElement('a')
    //   link.href = url
    //   link.download = fileName || '导出文件'
    //   link.target = '_blank'
    //   document.body.appendChild(link)
    //   link.click()
    //   document.body.removeChild(link)
    // }
    openDownloadFile (bizId, fileName) {
      // 下载文件
      if (bizId) {
        // 使用不经过拦截器处理的请求，直接使用axios
        axios({
          url: `${process.env.VUE_APP_API_BASE_URL}/api/exportlog/download`,
          method: 'POST',
          responseType: 'blob',
          headers: {
            [appConfig.ACCESS_TOKEN_NAME]: storage.getToken()
          },
          data: {
            bizId
          }
        }).then(res => {
          // 创建Blob对象
          const blob = new Blob([res.data])

          // 创建下载链接
          const downloadElement = document.createElement('a')
          const href = window.URL.createObjectURL(blob)

          // 从响应头中获取文件名，如果没有则使用默认名称
          let filename = fileName
          const contentDisposition = res.headers['content-disposition']
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename=(.+)/)
            if (filenameMatch && filenameMatch[1]) {
              filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''))
            }
          }

          // 设置链接属性
          downloadElement.href = href
          downloadElement.download = filename
          document.body.appendChild(downloadElement)
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement)
          window.URL.revokeObjectURL(href) // 释放blob对象

          this.$message.success('文件下载成功')
        }).catch(error => {
          console.error('下载文件失败:', error)
          this.$message.error('文件下载失败，请稍后重试')
        })
      } else {
        this.$message.error('文件不存在')
      }
    }
  }
}
</script>
